// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-container[data-v-54307945]{background:#fff;padding:32px 16px}.pagination-container.hidden[data-v-54307945]{display:none}.model[data-v-54307945]{display:grid}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
